/**
 * iframe popup
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import lang from '../../lang/index';
import Loading from '../../component/loading';
import Modal from 'boron/ScaleModal';

const noop = function(){};

class IframePop  extends Component {
    static defaultProps = {
        onHide: noop,
        url: '',
        closeOnClick: true,
        landscape: 0 // 1: 横屏，0:竖屏
    }
    constructor(props){
        super(props);

        this.state = {
            loading: 1
        }

        let clientHeight, _width, width, _height, height;

        clientHeight = document.documentElement && document.documentElement.clientHeight || body && body.offsetHeight || window.innerHeight || 395;
        _height = Math.min(Math.floor(clientHeight - 40), 812);
        _width = Math.floor(_height * 395 / 645);

        if (props.landscape == 1) {
            width = _height;
            height = _width; 
        } else {
            width = _width;
            height = _height;
        }

        this.style = {
            modalStyle: {
                width: width,
                height: height,   
                zIndex: 10070,
                transform: "none",
                left: '50%',
                top: '50%',
                marginLeft: - width / 2 + 'px',
                marginTop: - height /2 + 'px'
            },
            contentStyle: {
                width: width,
                height: height,        
                backgroundColor: '#fff',
                borderRadius: '10px',
                outline: 0
            },
            backdropStyle: {
                backgroundColor: "rgba(23,19,31, 0.7)",
                zIndex: 10060
            }
        }
    }

    componentDidMount() {
        this.showModal();
    }

    insertIframe() {
        var frame = this.create(this.props.url);

        $(frame).on('load', (e) => {
           this.setState({
                loading: 0
           });
        });
        // console.log(frame);
        // console.log($('#iframeWrap'));
        $('#iframeWrap').html(frame);
    }

    create(url) {
        var frame = document.createElement('iframe');
        frame.style.border = '0 none';
        frame.style.verticalAlign = 'top';
        frame.src = url;
        return frame;
    }


    showModal(){
        this.refs.modal.show();
    }

    hideModal(){
        this.refs.modal.hide();   
    }

    onShow() {
        // 禁用滚动条，并固定在当前位置
        var doc = $(document), 
            win = $(window), 
            winWidth = win.width(), 
            winHeight = win.height(),
            docHeight = doc.height(), 
            scrollY = doc.scrollTop();

        $('html')
            .css({
                'width': winWidth + 'px', 
                'height': winHeight + 'px', 
                'overflowY': 'hidden'
            })
            .scrollTop(scrollY);

        this.insertIframe();
        this.bindEvent();
    }

    bindEvent(){
        $(window).off('message');
        $(window).on('message', (e) =>{
            /**
             * e: {Object}
             *   {
             *      method: 'init',
             *      cbKey: '',
             *      params: '',
             *  }
             */
            var data = e.data;
            var method = data.method;
            var params = data.params || {};
            
            if (method == 'gopay') {
                this.hideModal();
                window.hashHistory.push('/recharge');
            } else if (method == 'login') {
                this.hideModal();
                $.channel.emit('login');
            } else if (method == 'profile') {
                window.hashHistory.push('/profile/base/' + params.uid);
            } else if (method == 'refreshProfile') {
                $.channel.emit('refreshProfile');
            }
        });
    }

    onHide() {
        // 页面恢复原始位置
        $('html')
            .css({
                'height': 'auto', 
                'width': 'auto',
                'overflowY': 'auto'
            })
            .scrollTop($(document).scrollTop());

        $(window).off('message');

        this.props.onHide();
    }

    render() {
        let style = this.style;
        let modalStyle = style.modalStyle;
        let backdropStyle = style.backdropStyle;
        let contentStyle = style.contentStyle;
        
        if (this.props.modalStyle) {
            for (let style in this.props.modalStyle) {
                modalStyle[style] = this.props.modalStyle[style];
            }
        }

        if (this.props.backdropStyle) {
            for (let style in this.props.backdropStyle) {
                backdropStyle[style] = this.props.backdropStyle[style];
            }
        }

        if (this.props.contentStyle) {
            for (let style in this.props.contentStyle) {
                contentStyle[style] = this.props.contentStyle[style];
            }
        }
        return (
            <Modal 
                ref="modal" 
                modalStyle={modalStyle} 
                backdropStyle={backdropStyle} 
                contentStyle={contentStyle} 
                onShow={this.onShow.bind(this)} 
                onHide={this.onHide.bind(this)}
                closeOnClick={this.props.closeOnClick}
            >
                <div className="overlay-frame-box">
                    <div className="close" onClick={()=>this.hideModal()}>x</div>
                    <div className="content" id="iframeWrap"></div>
                    { this.state.loading == 1 ? <div className="iframe-poster"><Loading/></div> : null }
                </div>
            </Modal>
        );
    }
}


module.exports = {
    create: function (cfg) {
        cfg = cfg || {};
        
        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();
        
        this.layer = ReactDOM.render(
            <IframePop {...cfg} onHide={this.onHide.bind(this, cfg)}/>,
            mountNode
        );
    },
    onHide: function(cfg){
        if (this.layer) {
            this.destroy();
        }
        if (typeof cfg.onHide == 'function') {
            cfg.onHide();
        }
    },
    // 创建组件插入的DOM节点
    createMountNode: function() {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy : function () {
        ReactDOM.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    }
};


// WEBPACK FOOTER //
// ./js/lib/popup/iframe.js